/**
 * File size limits for bank LC validation
 */
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB per file
export const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB total for multiple files
export const MAX_ZIP_SIZE = 100 * 1024 * 1024; // 100MB for ZIP files

